import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

//components
import EmptySpace from '../common/EmptySpace';

const BackgroundImage = props => {

    const { alt, backgroundImage, emptySpace, urlAssets } = props;

    return (
        <article className="position-relative w-100 mx-auto">
            { emptySpace && <EmptySpace /> }
            <LazyLoadImage
                alt={alt}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}img/${backgroundImage}.jpg`}
                wrapperClassName="w-100"
            />
        </article>
    )
}

export default BackgroundImage

BackgroundImage.propTypes = {
    alt: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    emptySpace: PropTypes.bool.isRequired,
    urlAssets: PropTypes.string.isRequired
}
